import PropTypes from 'prop-types'
import {isString} from '@republic/foundation/lang/is'

const
    type = PropTypes.oneOfType([
        PropTypes.oneOf(['x', 'y']),
        PropTypes.bool
    ]),

    repeat = value => ({
        backgroundRepeat: (
            isString(value) ?
                `repeat-${value}` :
                value ? 'repeat' : 'no-repeat')
    })

export {repeat, type}
